export const COLUMNSPENGELUARAN = [
  {
    Header: 'ID',
    accessor: 'id',
  },
  {
    Header: 'Nama Pengeluaran',
    accessor: 'nama_pengeluaran',
  },
  {
    Header: 'Jenis Pengeluaran',
    accessor: 'jenis_pengeluaran',
  },
  {
    Header: 'Waktu Pengeluaran',
    accessor: 'waktuPengeluaran',
  },
  {
    Header: 'Harga Pengeluaran',
    accessor: 'hargaPengeluaran',
  },
  {
    Header: 'Jumlah Barang',
    accessor: 'jumlah_barang',
  },
  {
    Header: 'Satuan',
    accessor: 'satuan',
  },
  {
    Header: 'Total Pengeluaran',
    accessor: 'totalPengeluaran',
  },
  {
    Header: 'Aksi',
    accessor: 'actions',
  },
];